<mat-accordion>
  @for (group of group; track group) {
    <div style="padding-bottom: 24px;">
      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title class="d-flex title-justify-content">
            <div>
              {{ group.description }}
            </div>
            <div>
              @if (!editing) {
                <button class="button" (click)="UpdateGroupButton(group)">
                  <img src="../../../assets/Icons/edit.png" width="20px" height="20px"/>
                </button>
              }
              @if (editing) {
                <button class="button" (click)="handleRemoveGroup(group)">
                  <img src="../../../assets/Icons/trash.png" width="20px" height="20px"/>
                </button>
              }
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <table class="w-100">
          <tr>
            <th class="w-column bordered-cell no-border-left">Referencia</th>
            <th class="w-column bordered-cell no-border-right">Descrição do Produto</th>
            @if (editing) {
              <th class="bordered-cell no-border-right"> </th>
            }
          </tr>
          @if (group.products && group.products.length > 0) {
            @for (product of group.products; track product) {
              <tr>
                <td class="w-column bordered-cell no-border-left">{{ product.reference }}</td>
                <td class="w-column bordered-cell no-border-right">{{ product.memory }}</td>
                @if (editing) {
                  <td class="buttons-content bordered-cell no-border-right">
                    <button class="button" (click)="handleRemoveProduct(product, group)">
                      <img src="../../../assets/Icons/trash.png" width="20px" height="20px"/>
                    </button>
                  </td>
                }
              </tr>
            }
          }
        </table>
      </mat-expansion-panel>
    </div>
  }
</mat-accordion>
